export const GET_PAIRING = 'GET_PAIRING'
export const ADD_PAIRING = 'ADD_PAIRING'
export const UPDATE_PAIRING = 'UPDATE_PAIRING'
export const RESET_EDIT_PAIRING = 'RESET_EDIT_PAIRING'
export const DELETE_PAIRING = 'DELETE_PAIRING'
export const RESET_DELETE_PAIRING = 'RESET_DELETE_PAIRING'
export const UPDATE_RESULT = 'UPDATE_RESULT'
export const RESET_UPDATE_RESULT = 'RESET_UPDATE_RESULT'
